module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/029-comoros-1054c6a7c127c28028ad37b9cd3d2f8c.svg";